import { render, staticRenderFns } from "./ListValue.vue?vue&type=template&id=f970f558&scoped=true"
import script from "./ListValue.vue?vue&type=script&lang=js"
export * from "./ListValue.vue?vue&type=script&lang=js"
import style0 from "./ListValue.vue?vue&type=style&index=0&id=f970f558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f970f558",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VCol,VIcon,VRow,VTooltip})
